import * as qs from 'qs';
import { injectable } from '../../../modules/common/di';
import { Dal } from '@peoplepower/webcore/dist/types/data/dal/dal';
import { AuthInterceptor } from '@peoplepower/webcore/dist/types/data/dal/interceptors/authInterceptor';
import { ApiResponseInterceptor } from '@peoplepower/webcore/dist/types/data/dal/interceptors/apiResponseInterceptor';
import { BaseUrlInterceptor } from '@peoplepower/webcore/dist/types/data/dal/interceptors/baseUrlInterceptor';
import { JsonContentTypeInterceptor } from '@peoplepower/webcore/dist/types/data/dal/interceptors/jsonContentTypeInterceptor';
import { OfflineInterceptor } from '@peoplepower/webcore/dist/types/data/dal/interceptors/offlineInterceptor';

@injectable('AdminApiDal')
export class AdminApiDal extends Dal {
  constructor() {
    const offlineInterceptor = new OfflineInterceptor();

    super(
      {
        // Custom params serializer
        paramsSerializer: (params) => {
          return qs.stringify(params, {
            arrayFormat: 'repeat', // This will make {a: ['b', 'c']} compiles to 'a=b&a=c' not 'a[]=b&a[]=c'
            // indices: false
          });
        },
      },
      [
        new BaseUrlInterceptor('/admin/json/'),
        offlineInterceptor,
        new AuthInterceptor(),
        new ApiResponseInterceptor(),
        new JsonContentTypeInterceptor(),
      ],
    );

    offlineInterceptor.dal = this;
  }
}
